import { EventEmitter } from '@angular/core';
import { UtilsService } from 'Angular/services/core/utils.service';
import { VRGLIntegrationService } from 'IntegrationsApp/ts/services/vrgl-integration-service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/utils.service";
import * as i2 from "IntegrationsApp/ts/services/vrgl-integration-service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i6 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i8 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function VRGLActivateModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 8);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Sending email...");
} }
function VRGLActivateModalComponent_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function VRGLActivateModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11)(3, "form", 12);
    i0.ɵɵtemplate(4, VRGLActivateModalComponent_div_4_div_4_Template, 1, 1, "div", 13);
    i0.ɵɵelementStart(5, "div", 14)(6, "b");
    i0.ɵɵtext(7, "Please enter your information below to submit the VRGL Integration request:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 14);
    i0.ɵɵtext(9, " By submitting your information below, YCharts will submit a request to VRGL for the integration on your behalf. Once confirmed, the integration will be activated and you'll be able to import holdings. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 14)(11, "div", 15);
    i0.ɵɵtext(12, "Firm Name:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "input", 16, 0);
    i0.ɵɵlistener("blur", function VRGLActivateModalComponent_div_4_Template_input_blur_13_listener() { i0.ɵɵrestoreView(_r1); const firmNameInput_r3 = i0.ɵɵreference(14); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setFirmName(firmNameInput_r3.value)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(15, "div", 14)(16, "div", 15);
    i0.ɵɵtext(17, "VRGL Account Email:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "input", 16, 1);
    i0.ɵɵlistener("blur", function VRGLActivateModalComponent_div_4_Template_input_blur_18_listener() { i0.ɵɵrestoreView(_r1); const emailInput_r4 = i0.ɵɵreference(19); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setEmail(emailInput_r4.value)); });
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage !== "");
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("placeholder", "Enter firm name");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("placeholder", "Enter VRGL account email");
} }
export class VRGLActivateModalComponent {
    constructor(utilsService, vrglIntegrationService) {
        this.utilsService = utilsService;
        this.vrglIntegrationService = vrglIntegrationService;
        this.closeModalHandler = new EventEmitter();
        this.confirmHandler = new EventEmitter();
        this.errorMessage = '';
        this.vrglAccountEmail = '';
        this.firmName = '';
        this.loading = false;
        this.modalOpen = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.closeModalHandler.emit();
    }
    setEmail(vrglAccountEmail) {
        this.vrglAccountEmail = vrglAccountEmail;
    }
    setFirmName(firmName) {
        this.firmName = firmName;
    }
    onSubmit() {
        this.vrglIntegrationService.sendVRGLRequestEmail(this.firmName, this.vrglAccountEmail).subscribe({
            next: () => {
                this.closeModal();
            },
            error: (err) => {
                this.loading = false;
                this.errorMessage = err.error.errorMessage;
            },
        });
    }
}
VRGLActivateModalComponent.ɵfac = function VRGLActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || VRGLActivateModalComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i2.VRGLIntegrationService)); };
VRGLActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: VRGLActivateModalComponent, selectors: [["ycn-vrgl-integration-activate-modal"]], outputs: { closeModalHandler: "closeModalHandler", confirmHandler: "confirmHandler" }, standalone: false, decls: 6, vars: 7, consts: [["firmNameInput", ""], ["emailInput", ""], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText", "disableSubmission"], [3, "loaderMessage"], [1, "modal-section"], [1, "row"], [1, "col"], ["action", "javascript:void(0);"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], [1, "form-label", "form-label-thin"], ["type", "text", "autocomplete", "username", 1, "form-control", 3, "blur", "placeholder"], [1, "form-row", "text-red", 3, "textContent"]], template: function VRGLActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function VRGLActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function VRGLActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵtemplate(3, VRGLActivateModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 5)(4, VRGLActivateModalComponent_div_4_Template, 20, 3, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("cancelHandler", function VRGLActivateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.closeModal(); })("submitHandler", function VRGLActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate VRGL Integration");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Send Request to VRGL")("disableSubmission", ctx.loading || ctx.vrglAccountEmail === "" || ctx.firmName === "");
    } }, dependencies: [i3.NgIf, i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.NgForm, i5.LoadingSymbolComponent, i6.ModalBaseComponent, i7.SimpleModalFooterComponent, i8.SimpleModalHeaderComponent], encapsulation: 2 });
